import styled from 'styled-components'

export const Background = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 100vh;

  overflow: inherit;
  overflow-y: inherit;

  z-index: 9996;
  background: rgba(0, 0, 0, 0.5);
  padding: 1rem;
`

export const Container = styled.div`
  background: white;
  margin-left: 200px;
  border-radius: 0.25rem;
  padding: 2rem;

  z-index: 9997;
  box-shadow: 1px 1px 4px 2px rgba(0, 0, 0, 0.2);

  max-height: 70%;
  overflow: auto;
`
